import Link from 'next/link';

import styles from './toggle-menu-list.component.module.scss';

type Props = {
  hideSettingsMenu?: boolean;
  hideProfileMenu?: boolean;
  profileCompletionProgress?: number;
  onClickLogoutButton: () => void;
};

export const ToggleMenuList = ({
  hideSettingsMenu,
  hideProfileMenu,
  profileCompletionProgress,
  onClickLogoutButton,
}: Props) => {
  return (
    <>
      {!hideProfileMenu && (
        <li>
          <Link href="/settings/profile">
            プロフィール
            {profileCompletionProgress !== 100 && (
              <span
                aria-label="プロフィールに未入力項目があります"
                className={styles.profileIncompletionMark}
              />
            )}
          </Link>
        </li>
      )}
      {!hideSettingsMenu && (
        <li>
          <Link href="/settings/block_setting">設定</Link>
        </li>
      )}
      <li>
        <Link href="/others/inquiry">お問い合わせ・退会</Link>
      </li>
      <li>
        <button className={styles.logoutButton} onClick={onClickLogoutButton}>
          ログアウト
        </button>
      </li>
    </>
  );
};
